const setTicketData = (data: any) => {
  return {
    id: data.id,
    number: data.number,
    title: data.title,
    firstAnswer: data.firstAnswer.contentWithoutTags,
    reportedBy: data.reportedBy,
    unreaded: data.isUnread,
    dateLastAnswer: data.dateLastActivity.date,
    added: data.createdAt.date,
    urgent: data.isUrgent,
    client: data.client
      ? {
          id: data.author.id,
          name: data.author.name,
        }
      : null,
    assignedUsers: data.assignedUsers,
    addedBy: {
      id: data.author.id,
      name: data.author.name,
    },
    mailAccount: data.mailAccount,
    tags: data.tags,
    avatar: data.author.avatar,
    isMine: data.isMine,
    ticketCategory: data.category,
    ticketSubcategory: data.subcategory,
    ticketCategoryStatus: data.categoryStatus,
  }
}

export const websocket = (
  channel,
  setItems,
  itemsRef,
  viewRef,
  searchRef,
  filterRef,
  setUnreadTickets
) => {
  channel.on('created', (data: any) => {
    if (viewRef.current == 'closed') {
      return
    }

    if (searchRef.current) {
      return
    }

    if (
      filterRef.current.category &&
      data.category.id != filterRef.current.category
    ) {
      return
    }

    if (
      filterRef.current.subcategory &&
      data.subcategory.id != filterRef.current.subcategory
    ) {
      return
    }

    if (
      filterRef.current.categoryStatus &&
      data.categoryStatus.id != filterRef.current.categoryStatus
    ) {
      return
    }

    if (
      filterRef.current.mailAccount &&
      data.mailAccountId != filterRef.current.mailAccount
    ) {
      return
    }

    if (
      filterRef.reportedBy &&
      parseInt(data.reportedBy) != filterRef.current.reportedBy
    ) {
      return
    }

    if (
      filterRef.current.title &&
      !data.title.includes(filterRef.current.title)
    ) {
      return
    }

    const { urgentFirst } = window.c.ticketSortSettings

    const position = (() => {
      const starsLength = itemsRef.current.filter(i => i.stars).length
      const item = data

      if (!urgentFirst) {
        return starsLength
      } else {
        const urgentNotStarsLength = itemsRef.current.filter(
          i => i.urgent && !i.stars
        ).length

        if (item.isUrgent) {
          return starsLength
        } else {
          return starsLength + urgentNotStarsLength
        }
      }
    })()

    const newData = setTicketData(data)

    if (position !== 0) {
      setItems(items => [
        ...items.slice(0, position),
        newData,
        ...items.slice(position, items.length),
      ])
    } else {
      setItems(items => [newData, ...items])
    }
  })

  channel.on('ticketStats', (data: { unreaded: number }) => {
    setUnreadTickets(data.unreaded)
  })

  channel.on('updated', (data: any) => {
    if (
      data.state &&
      (filterRef.current.view == 'open' || filterRef.current.view == 'todo')
    ) {
      setItems(items => items.filter(item => item.id != data.id))
      return
    }

    if (!data.state && filterRef.current.view == 'closed') {
      setItems(items => items.filter(item => item.id != data.id))
      return
    }

    if (searchRef.current) {
      return
    }

    const newData = setTicketData(data)

    setItems(items =>
      items.map(item => (item.id == data.id ? { ...item, ...newData } : item))
    )
  })

  channel.on('starred', (data: any) => {
    if (searchRef.current) {
      return
    }

    if (data.userId == window.c.userId) {
      setItems(items =>
        items.map(item =>
          item.id == data.ticketId
            ? { ...item, stars: [{ colorId: data.colorId }] }
            : item
        )
      )
    }
  })
}
